import { useState } from "react";
import { T, base } from "../lib/theme";
import { apiFetch } from "../lib/api";
import { Icon, Btn, Input } from "./index";

const ConnectionModal = ({ onClose, onQR, onMeta }) => {
  const [method,         setMethod]         = useState(null); // null | "qr" | "meta"
  const [metaToken,      setMetaToken]      = useState("");
  const [metaPhoneId,    setMetaPhoneId]    = useState("");
  const [metaVerifyToken,setMetaVerifyToken]= useState("");
  const [saving,         setSaving]         = useState(false);
  const [saved,          setSaved]          = useState(false);

  const connectMeta = async () => {
    if (!metaToken || !metaPhoneId) return;
    setSaving(true);
    try {
      await apiFetch("/api/connect-meta", {
        method: "POST",
        body: JSON.stringify({
          accessToken:  metaToken,
          phoneNumberId: metaPhoneId,
          verifyToken:  metaVerifyToken,
        }),
      });
      setSaved(true);
      setTimeout(() => { onMeta(); onClose(); }, 1200);
    } catch {
      setSaving(false);
    }
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 1000,
        background: "rgba(0,0,0,0.7)", backdropFilter: "blur(6px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        animation: "fadeSlideIn 0.2s ease",
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          width: 560, background: T.bg1,
          border: `1px solid ${T.border2}`,
          borderRadius: 20, overflow: "hidden",
          animation: "fadeSlideIn 0.25s ease",
        }}
      >
        {/* Header */}
        <div style={{
          padding: "20px 24px", borderBottom: `1px solid ${T.border1}`,
          display: "flex", alignItems: "center", justifyContent: "space-between",
        }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: T.text1 }}>Connect WhatsApp</div>
            <div style={{ fontSize: 13, color: T.text3, marginTop: 2 }}>Choose how you want to connect</div>
          </div>
          <button onClick={onClose}
            style={{ background: "none", border: "none", cursor: "pointer", color: T.text3, display: "flex" }}>
            <Icon name="x" size={20} />
          </button>
        </div>

        <div style={{ padding: 24 }}>
          {!method ? (
            /* Method selection cards */
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
              {/* QR */}
              <div className="connect-card" onClick={() => { setMethod("qr"); onQR(); onClose(); }}
                style={{ padding: 24, borderRadius: 16, cursor: "pointer", border: `1px solid ${T.border2}`, background: T.bg2, transition: "all 0.2s" }}>
                <div style={{ width: 48, height: 48, borderRadius: 14, background: "linear-gradient(135deg, rgba(56,189,248,0.2), rgba(56,189,248,0.05))", border: `1px solid rgba(56,189,248,0.2)`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
                  <Icon name="qr" size={22} color={T.sky} />
                </div>
                <div style={{ fontSize: 15, fontWeight: 600, color: T.text1, marginBottom: 6 }}>QR Code</div>
                <div style={{ fontSize: 13, color: T.text3, lineHeight: 1.6 }}>
                  Scan with your WhatsApp app. Quick setup, personal number.
                </div>
                <div style={{ marginTop: 14, display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: T.sky }}>
                  <Icon name="check" size={12} color={T.sky} /> Recommended for personal use
                </div>
              </div>

              {/* Meta API */}
              <div className="connect-card" onClick={() => setMethod("meta")}
                style={{ padding: 24, borderRadius: 16, cursor: "pointer", border: `1px solid ${T.border2}`, background: T.bg2, transition: "all 0.2s" }}>
                <div style={{ width: 48, height: 48, borderRadius: 14, background: "linear-gradient(135deg, rgba(139,92,246,0.2), rgba(139,92,246,0.05))", border: `1px solid rgba(139,92,246,0.2)`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
                  <Icon name="meta" size={22} color={T.violet} />
                </div>
                <div style={{ fontSize: 15, fontWeight: 600, color: T.text1, marginBottom: 6 }}>Meta Cloud API</div>
                <div style={{ fontSize: 13, color: T.text3, lineHeight: 1.6 }}>
                  Official Business API. Best for high-volume business accounts.
                </div>
                <div style={{ marginTop: 14, display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: T.violet }}>
                  <Icon name="check" size={12} color={T.violet} /> Best for business / high volume
                </div>
              </div>
            </div>
          ) : method === "meta" ? (
            /* Meta API form */
            <div>
              <button onClick={() => setMethod(null)} style={{ display: "flex", alignItems: "center", gap: 6, background: "none", border: "none", cursor: "pointer", color: T.text3, fontSize: 13, marginBottom: 20, fontFamily: base.font }}>
                <Icon name="arrowLeft" size={14} color={T.text3} /> Back
              </button>
              <div style={{ padding: "12px 16px", borderRadius: 10, background: T.violetDim, border: "1px solid rgba(139,92,246,0.2)", marginBottom: 20, fontSize: 13, color: T.violet, lineHeight: 1.6 }}>
                You need a Meta Business account and a WhatsApp Business API phone number.
                Get credentials from the <strong>Meta Developer Console</strong>.
              </div>
              <Input label="Access Token"                  value={metaToken}       onChange={e => setMetaToken(e.target.value)}       placeholder="EAAxxxxxxxxxxxxxxxx..." />
              <Input label="Phone Number ID"               value={metaPhoneId}     onChange={e => setMetaPhoneId(e.target.value)}     placeholder="1234567890123456" />
              <Input label="Webhook Verify Token (optional)" value={metaVerifyToken} onChange={e => setMetaVerifyToken(e.target.value)} placeholder="my_verify_token" />
              <Btn size="lg" onClick={connectMeta}
                disabled={saving || !metaToken || !metaPhoneId}
                style={{ width: "100%", justifyContent: "center", background: saved ? T.online : T.violet, color: "#fff", border: "none" }}>
                {saved ? <><Icon name="check" size={14} color="#fff" /> Connected!</>
                       : saving ? "Connecting..." : "Connect via Meta API"}
              </Btn>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ConnectionModal;